import { SVGProps } from 'react';

const ReplyAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m12 7-5 5 5 5m-5-5h11a4 4 0 0 1 4 4v2M7 17l-5-5 5-5"
    />
  </svg>
);
export default ReplyAll;
